import { useRouter } from 'next/router';

export const useIgnoreAuth = () => {
  const router = useRouter();

  return {
    preventSignIn:
      router.asPath.includes('/auth') || router.asPath.startsWith('/a/'),
  };
};
